// TODO: Fix eslint errors.
/* eslint-enable no-unused-vars */
/* eslint-disable no-unused-vars */
import React from 'react';

function dispatchRerender() {
  // Dispatch event to re-attach orbit functionality.
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event('react-rerender'));
  }
}

export default dispatchRerender;
